// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._4w5RkRG7x{padding:8px 0;position:relative}._4w5RkRG7x:first-child{padding-top:0}._4w5RkRG7x::before{content:'';position:absolute;top:0;left:8px;right:8px;height:1px;background-color:var(--ui-divider)}@media screen and (-ms-high-contrast: active){._4w5RkRG7x::before{background-color:windowText}}._4w5RkRG7x:first-child::before{display:none}._4w5RkRG7x:last-child{padding-bottom:0}._7omZTy0Nx{padding-top:16px}._7omZTy0Nx:first-child{padding-top:4px}._6TQstzBkx::before{background-color:rgba(255,255,255,0.1)}._25LEtlXJx{}._25LEtlXJx:empty{display:none}\n", "",{"version":3,"sources":["webpack://client/shared/dropdown/item-group.scss"],"names":[],"mappings":"AAAwmB,YAAY,aAAa,CAAC,iBAAiB,CAAC,wBAAwB,aAAa,CAAC,oBAAoB,UAAU,CAAC,iBAAiB,CAAC,KAAK,CAAC,QAAQ,CAAC,SAAS,CAAC,UAAU,CAAC,kCAAkC,CAAC,8CAA8C,oBAAoB,2BAA2B,CAAC,CAAC,gCAAgC,YAAY,CAAC,uBAAuB,gBAAgB,CAAC,YAAY,gBAAgB,CAAC,wBAAwB,eAAe,CAAC,oBAAc,sCAAsC,CAAC,YAA2D,CAAC,kBAAa,YAAY","sourcesContent":[":export{tabletScreen:768px;smallScreen:1100px;mediumScreen:1300px;largeScreen:1500px;azure:#006fc8;cyan:#1FAECE;primaryText:var(--primary-text);secondaryText:var(--secondary-text);chartGridColor:var(--ui-divider);gray10:#dedede;msDarkBlue:#002050;amberLight2:#F7E28B;violetLight2:#CEC0EC;tealLight3:#CFECE8;bannerBlue:var(--banner-blue);spaceXXS:4px;spaceXS:8px;spaceS:16px;spaceM:20px;spaceXM:24px;spaceL:32px;spaceXL:40px;spaceXXL:60px;panelSlideDuration:200ms;panelFadeDuration:100ms;ccBannerHeight:46px;chartCyan:var(--charts-cyan);chartMapBorders:var(--charts-map-border);chartMapBgDefault:var(--charts-map-bg)}.item-group{padding:8px 0;position:relative}.item-group:first-child{padding-top:0}.item-group::before{content:'';position:absolute;top:0;left:8px;right:8px;height:1px;background-color:var(--ui-divider)}@media screen and (-ms-high-contrast: active){.item-group::before{background-color:windowText}}.item-group:first-child::before{display:none}.item-group:last-child{padding-bottom:0}.with-title{padding-top:16px}.with-title:first-child{padding-top:4px}.dark::before{background-color:rgba(255,255,255,0.1)}.title{composes:padding-list-xs from '../styles/utils.scss'}.title:empty{display:none}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"item-group": "_4w5RkRG7x",
	"itemGroup": "_4w5RkRG7x",
	"with-title": "_7omZTy0Nx",
	"withTitle": "_7omZTy0Nx",
	"dark": "_6TQstzBkx",
	"title": "_25LEtlXJx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-xs"] + ""
};
export default ___CSS_LOADER_EXPORT___;
